import type { SyntheticEvent } from "react";

/** Swaps a failed event photo for the neutral fallback exactly once. */
export function fallbackOnError(fallback: string) {
  return (event: SyntheticEvent<HTMLImageElement>) => {
    const img = event.currentTarget;
    if (img.dataset["fallback"]) return;
    img.dataset["fallback"] = "1";
    img.removeAttribute("srcset");
    img.src = fallback;
  };
}
